import meta from 'utilities/meta';
import findParent from 'utilities/find-parent';

export default ($field) => {
    const $form = findParent($field, '.js-form');
    const $cardInput = $field.querySelector('.js-form__card-input');
    const $errorOutput = $field.querySelector('.js-form__field-errors');
    const $tokenInput = $field.querySelector('.js-form__card-token');

    // Stripe Components
    const stripe = Stripe(meta('application:stripe:publishableKey'));
    const elements = stripe.elements();
    const card = elements.create('card', {
        style: {
            base: {
                fontSize: '18px',
                lineHeight: '20px'
            }
        },
        classes: {
            focus: 'form__input--is-artificially-focused'
        }
    });

    const stripeTokenHandler = (token) => {
        // Insert the token ID into the form so it gets submitted to the server
        $tokenInput.value = token.id;

        // Submit the form
        $form.submit();
    }

    card.mount($cardInput);

    card.addEventListener('change', function(e) {
        if (e.error) {
            $errorOutput.textContent = e.error.message;
        } else {
            $errorOutput.textContent = '';
        }
    });

    $form.addEventListener('submit', (e) => {
        e.preventDefault();

        stripe.createToken(card).then((result) => {
            if (result.error) {
                // Inform the customer that there was an error.
                $errorOutput.textContent = result.error.message;
            } else {
                // Send the token to your server.
                stripeTokenHandler(result.token);
            }
        });
    });
};
